import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import AnimatedCounter from "../Shared/AnimatedCounter.js";
import tablets from "../assests/humans/tablets.svg";
import capsules from "../assests/humans/capsules.svg";
import liquids from "../assests/humans/liquids.svg";
import file from "../assests/api/Regulatory.svg";
import minLogo from "../assests/humans/images.svg";

const HomeIcon = () => (
    <svg className="human-health-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const dosageData = [
    { title: "Tablets", count: "38+", desc: "", icon: "pill" },
    { title: "Capsules", count: "8+", desc: "", icon: "cube" },
    { title: "Liquids/Syrups", count: "16+", desc: "", icon: "drop" },
];

const MarketedProducts = [
    {
        category: "Central Nervous System (CNS)",
        name: "Acamprosate Calcium DR",
        form: "Tablet, Delayed Release",
        strength: "333mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Doxepin",
        form: "Capsules",
        strength: "10mg, 25mg, 50mg, 75mg, 100mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Fluvoxamine Maleate ER",
        form: "ER Capsules",
        strength: "100mg, 150mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Haloperidol",
        form: "Tablets",
        strength: "0.5mg, 1mg, 2mg, 5mg, 10mg, 20mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Lamotrigine (Base)",
        form: "ODT",
        strength: "25mg, 50mg, 100mg, 200mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Modafinil (Base)",
        form: "Tablets",
        strength: "100mg, 200mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Perphenazine",
        form: "Tablets",
        strength: "2mg, 4mg, 8mg, 16mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Ramelteon",
        form: "Tablets",
        strength: "8mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Sertraline",
        form: "Capsules",
        strength: "150mg, 200mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Sertraline HCl",
        form: "Tablets",
        strength: "25mg, 50mg, 100mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Viloxazine HCl ER",
        form: "ER Capsules",
        strength: "100mg, 150mg, 200mg"
    },

    {
        category: "Cardiovascular System (CVS)",
        name: "Acetazolamide",
        form: "Tablets",
        strength: "125mg, 250mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Bumetanide (Base)",
        form: "Tablets",
        strength: "0.5mg, 1mg, 2mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Chlorthalidone",
        form: "Tablets",
        strength: "25mg, 50mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Labetalol",
        form: "Tablets",
        strength: "100mg, 200mg, 300mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Prazosin",
        form: "Capsules",
        strength: "1mg, 2mg, 5mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Rivaroxaban",
        form: "Granules for Suspension",
        strength: "1mg/ml"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Tranexamic Acid",
        form: "Tablets",
        strength: "650mg"
    },

    {
        category: "Gastrointestinal (GI)",
        name: "Oxybutynin Chloride",
        form: "Tablets",
        strength: "2.5mg, 5mg"
    },
    {
        category: "Gastrointestinal (GI)",
        name: "Prucalopride Succinate",
        form: "Tablets",
        strength: "1mg, 2mg"
    },

    {
        category: "Antibiotics",
        name: "Clindamycin (Palmitate HCl)",
        form: "Powder for Oral Suspension",
        strength: "75mg/5ml"
    },
    {
        category: "Antibiotics",
        name: "Nitrofurantoin",
        form: "Oral Suspension",
        strength: "25mg/5ml"
    },

    {
        category: "Anti-Histamine",
        name: "Cyproheptadine HCl",
        form: "Tablets",
        strength: "4mg"
    },
    {
        category: "Anti-Histamine",
        name: "Famotidine",
        form: "Powder for Oral Suspension",
        strength: "40mg/ml"
    },

    {
        category: "Anti-Retroviral",
        name: "Valganciclovir",
        form: "Powder for Oral Solution",
        strength: "50mg/ml"
    },

    {
        category: "Others",
        name: "Albuterol Sulfate",
        form: "Tablets",
        strength: "2mg, 4mg"
    },
    {
        category: "Others",
        name: "Clomiphene Citrate",
        form: "Tablets",
        strength: "50mg"
    },
    {
        category: "Others",
        name: "Glycopyrrolate (Base)",
        form: "Tablets",
        strength: "1mg, 2mg"
    },
    {
        category: "Others",
        name: "Hydroxychloroquine",
        form: "Tablets",
        strength: "100mg, 200mg, 300mg, 400mg"
    },
    {
        category: "Others",
        name: "Sildenafil",
        form: "Tablets",
        strength: "25mg, 50mg, 100mg"
    },
    {
        category: "Others",
        name: "Hydrocortisone",
        form: "Tablets",
        strength: "5mg, 10mg, 20mg"
    }
];

const developmentStageProducts = [
    {
        category: "Central Nervous System (CNS)",
        name: "Brivaracetam",
        form: "Tablet, Film coated",
        strength: "10mg, 25mg, 50mg, 75mg, 100mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Brivaracetam",
        form: "Oral Solution",
        strength: "10 mg/ml"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Edaravone",
        form: "Oral Suspension",
        strength: "105mg/5ml"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Xanomeline and Trospium chloride (NCE-1)",
        form: "Capsules",
        strength: "50 & 20 mg, 100 & 20 mg, 125 & 30 mg"
    },
    {
        category: "Central Nervous System (CNS)",
        name: "Zonisamide",
        form: "Oral Suspension",
        strength: "100mg/5ml"
    },

    {
        category: "Cardiovascular System (CVS)",
        name: "Azilsartan Kamedoxomil and Chlorthalidone",
        form: "Tablets",
        strength: "40 & 12.5mg; 40 & 25mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Diltiazem Hydrochloride ER",
        form: "Capsule, Extended Release",
        strength: "60mg, 90mg, 120mg"
    },
    {
        category: "Cardiovascular System (CVS)",
        name: "Treprostenil ER",
        form: "ER Tablet",
        strength: "0.125mg, 0.25mg, 1mg, 2.5mg, 5mg"
    },

    {
        category: "Gastrointestinal (GI)",
        name: "Esomeprazole magnesium granule, DR",
        form: "Granules, Delayed Release",
        strength: "2.5 mg, 5 mg, 10 mg, 20 mg & 40 mg"
    },
    {
        category: "Gastrointestinal (GI)",
        name: "Linaclotide Capsules",
        form: "Capsules",
        strength: "72mcg, 145mcg, 290mcg"
    },
    {
        category: "Gastrointestinal (GI)",
        name: "Magnesium Sulfate + Potassium Chloride + Sodium Sulfate (Sutab)",
        form: "Tablets",
        strength: "0.225g & 0.188g & 1.479g"
    },
    {
        category: "Gastrointestinal (GI)",
        name: "Sodium sulfate, magnesium sulfate, and potassium chloride (SUTAB)",
        form: "Tablet, Film coated",
        strength: "1.479 g & 0.225 g & 0.188 g"
    },
    {
        category: "Gastrointestinal (GI)",
        name: "Sodium picosulfate, magnesium oxide, and anhydrous citric acid (Clenpiq)",
        form: "Solution",
        strength: "10 mg & 3.5 g & 12 g"
    },
    {
        category: "Gastrointestinal (GI)",
        name: "Vonoprazan (Fumarate)",
        form: "Tablet, Film coated",
        strength: "10 mg, 20 mg"
    },

    {
        category: "Anti-Histamine",
        name: "Hydroxyzine HCl",
        form: "Oral Solution",
        strength: "10mg/5ml"
    },

    {
        category: "Antibiotics",
        name: "Vancomycin",
        form: "Powder for Oral Solution",
        strength: "250mg/5ml"
    },
    {
        category: "Antibiotics",
        name: "Erythromycin Ethylsuccinate",
        form: "Powder for Oral Solution",
        strength: "EQ 200mg/5ml, EQ 400mg/5ml"
    },

    {
        category: "Others",
        name: "Avatrombopag maleate",
        form: "Tablet, Film coated",
        strength: "20 mg"
    },
    {
        category: "Others",
        name: "Deflazacort",
        form: "Tablets",
        strength: "6mg, 18mg, 30mg, 36mg"
    },
    {
        category: "Others",
        name: "Sodium Polystyrene Sulfonate (SPS) Suspension",
        form: "Suspension",
        strength: "15g/60ml"
    },
    {
        category: "Others",
        name: "Sapropterin dihydrochloride",
        form: "Powder for Solution",
        strength: "100mg/Pkt, 500mg/Pkt"
    }
];
const manufacturingData = [
    {
        tech: "High-Speed Compression",
        desc: "Advanced tablet compression systems",
        pack: "Blister Packing",
    },
    {
        tech: "Fluid Bed Processing",
        desc: "Granulation and coating technology",
        pack: "Bottle Filling",
    },
    {
        tech: "Coating Technologies",
        desc: "Film coating and sugar coating",
        pack: "Stick Packs",
    },
    {
        tech: "Aseptic Fill-Finish",
        desc: "Sterile injectable manufacturing",
        pack: "Sachets",
    },
    {
        tech: "Lyophilization",
        desc: "Freeze-drying for injectables",
        pack: "Vial Filling",
    },
    {
        tech: "Continuous Manufacturing",
        desc: "Modern continuous processing",
        pack: "Pre-filled Syringes",
    },
];
const pipelineData = [
    {
        id: 1,
        category: "Oncology",
        name: "Dimethylsulfoxide Tablets",
        strength: "0.5 mg, 2 mg",
        filing: "Dec-26",
        approval: "Mar-28",
        launch: "Oct-30"
    },
    {
        id: 2,
        category: "Oncology",
        name: "Lorlatinib Tablets",
        strength: "25mg, 100mg",
        filing: "Jan-27",
        approval: "May-28",
        launch: "Mar-33"
    },
    {
        id: 3,
        category: "Oncology",
        name: "Venetoclax Tablets",
        strength: "10 mg, 50 mg, 100 mg",
        filing: "Dec-26",
        approval: "Mar-28",
        launch: "Jun-31"
    },

    {
        id: 4,
        category: "Central Nervous System (CNS)",
        name: "Cyclobenzaprine Sublingual Tablets",
        strength: "2.8mg",
        filing: "Jun-26",
        approval: "Aug-27",
        launch: "Mar-30"
    },
    {
        id: 5,
        category: "Central Nervous System (CNS)",
        name: "Perampanel Oral Suspension",
        strength: "0.5mg/ml",
        filing: "Jul-26",
        approval: "Aug-27",
        launch: "Aug-28"
    },
    {
        id: 6,
        category: "Central Nervous System (CNS)",
        name: "Xanomeline and Trospium chloride Capsules [NCE-1]",
        strength: "50 & 20 mg, 100 & 20 mg, 125 & 30 mg",
        filing: "Jul-26",
        approval: "Sep-28",
        launch: "Jun-31"
    },

    {
        id: 7,
        category: "Anti-Infective",
        name: "Letermovir Tablet",
        strength: "240mg, 480mg",
        filing: "Sep-26",
        approval: "Nov-27",
        launch: "Jul-30"
    },
    {
        id: 8,
        category: "Anti-Infective",
        name: "Letermovir Pellets",
        strength: "20mg, 120mg",
        filing: "Sep-26",
        approval: "Nov-27",
        launch: "Jul-30"
    },
    {
        id: 9,
        category: "Anti-Infective",
        name: "Posaconazole Oral Suspension",
        strength: "40 mg/mL",
        filing: "Jun-26",
        approval: "Sep-27",
        launch: "Aug-28"
    },

    {
        id: 10,
        category: "Cardiovascular System (CVS)",
        name: "Acoramidis Tablets [NCE-1]",
        strength: "360 mg",
        filing: "Oct-26",
        approval: "Nov-28",
        launch: "Jun-35"
    },

    {
        id: 11,
        category: "Others",
        name: "Ferric Maltol Capsule",
        strength: "30 mg",
        filing: "Nov-26",
        approval: "Dec-27",
        launch: "Sep-30"
    },
    {
        id: 12,
        category: "Others",
        name: "Hydroxy Urea Oral Solution",
        strength: "100 mg/mL",
        filing: "Jun-26",
        approval: "Apr-27",
        launch: "Apr-31"
    },
    {
        id: 13,
        category: "Others",
        name: "Megestrol Oral Suspension",
        strength: "40 mg/mL",
        filing: "Aug-26",
        approval: "Oct-27",
        launch: "Oct-28"
    },
    {
        id: 14,
        category: "Others",
        name: "Megestrol Oral Suspension",
        strength: "125mg/mL",
        filing: "Sep-26",
        approval: "Nov-27",
        launch: "Oct-28"
    },
    {
        id: 15,
        category: "Others",
        name: "Patiromer Sorbitex Calcium for Oral Suspension",
        strength: "EQ 1gm, EQ 8.4gm, EQ 16.8gm, EQ 25.2gm base/packet",
        filing: "Nov-26",
        approval: "Dec-27",
        launch: "Jan-31"
    },
    {
        id: 16,
        category: "Others",
        name: "Perfluorohexyloctane Ophthalmic Solution [NCE-1]",
        strength: "1.338 g/mL",
        filing: "Jul-26",
        approval: "May-27",
        launch: "Jul-36"
    },
    {
        id: 17,
        category: "Others",
        name: "Resmitrom Tablets [NCE-1]",
        strength: "60mg, 80mg, 100mg",
        filing: "Aug-26",
        approval: "Mar-28",
        launch: "Sep-31"
    }
];

const Icon = ({ type }) => {
    switch (type) {
        case "pill": return <img src={tablets} alt="Tablets" />;
        case "cube": return <img src={capsules} alt="Capsules" />;
        case "drop": return <img src={liquids} alt="Liquids" />;
        default: return null;
    }
};


const filters = [
    { name: "All Categories" },
    { name: "CNS" },
    { name: "CVS" },
    { name: "GI" },
    { name: "Anti-Histamine" },
    { name: "Anti-Retroviral" },
    { name: "Others" }
];

const developfilters = [
    { name: "All Categories" },
    { name: "CNS" },
    { name: "CVS" },
    { name: "GI" },
    { name: "Anti-Histamine" },
    { name: "Antibiotics" },
    { name: "Others" }
];

const pipelineFilters = [
    { name: "All Categories" },
    { name: "Oncology" },
    { name: "CNS" },
    { name: "Anti-Infective" },
    { name: "CVS" },
    { name: "Others" }
];

const HumanHealth = () => {
    const [search] = useState("");
    const [activeCategory, setActiveCategory] = useState("All Categories");

    const filteredData = MarketedProducts.filter((api) => {
        const matchesSearch = api.name.toLowerCase().includes(search.toLowerCase());
        const matchesCategory = activeCategory === "All Categories" ||
            api.category.toLowerCase().includes(activeCategory.toLowerCase());

        return matchesSearch && matchesCategory;
    });

    const filteredDevData = developmentStageProducts.filter((api) => {
        const matchesCategory = activeCategory === "All Categories" ||
            api.category.toLowerCase().includes(activeCategory.toLowerCase());

        return matchesCategory;
    });

    const filteredPipelineData = pipelineData.filter((api) => {
        const matchesCategory = activeCategory === "All Categories" ||
            api.category.toLowerCase().includes(activeCategory.toLowerCase());

        return matchesCategory;
    });

    return (
        <div className="human-health-page">

            <section className="human-health-hero-section">
                <div className="human-health-hero-overlay"></div>
                <div className="human-health-hero-content">
                    <h1 className="human-health-hero-title">
                        Human Health Care<br />
                        Excellence in Pharmaceuticals
                    </h1>
                </div>
            </section>

            <div className="human-health-breadcrumb-container">
                <div className="human-health-breadcrumb-wrapper">
                    <div className="human-health-breadcrumb-links">
                        <Link
                            to="/"
                            className="human-health-breadcrumb-link human-health-home-link"
                        >
                            <HomeIcon /> Home
                        </Link>
                        <span className="human-health-breadcrumb-separator">›</span>
                        <span className="human-health-breadcrumb-current">Human Health</span>
                    </div>
                </div>
            </div>



            <div className="human-health-table-section">
                {/* FILTER BAR */}
                <h2 className="human-health-api-title">Marketed Products</h2>

                <div className="human-health-api-section-divider">
                    <span className="human-health-api-line left"></span>

                    <div className="human-health-api-icon-circle">
                        <img src={minLogo} alt="company overview" />
                    </div>

                    <span className="human-health-api-line right"></span>
                </div>
                <p className="human-health-api-subtitle">50 finished dosage products across 7 categories</p>

                <div className="human-health-filter-container">
                    <div className="human-health-filter-left">
                        <div className="human-health-filter-buttons">
                            {filters.map((item) => (
                                <button
                                    key={item.name}
                                    className={`human-health-filter-pill ${item.name.replace(/\s+/g, '-')} ${item.name === activeCategory ? "active" : ""}`}
                                    onClick={() => setActiveCategory(item.name)}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* <div className="human-health-search-box">
                        <input
                            type="text"
                            placeholder="Search products..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div> */}
                </div>

                {/* HEADER */}
                {/* <div className="human-health-table-header">
                    <span>
                        Showing <b>{filteredData.length}</b> products ·{" "}
                        <span className="human-health-green">{activeCategory}</span>
                    </span>
                    <span
                        className="human-health-clear"
                        onClick={() => {
                            setSearch("");
                            setActiveCategory("All Categories");
                        }}
                    >
                        Clear filters
                    </span>
                </div> */}

                {/* TABLE */}
                <div className="human-health-table-wrapper">
                    <table className="human-health-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product</th>
                                {/* <th>Category</th> */}
                                <th>Dosage Form</th>
                                <th>Strength(s)</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredData.map((api, index) => (
                                <tr key={index}>
                                    <td className="api-id">{index + 1}</td>
                                    <td className="product-name">{api.name}</td>
                                    {/* <td>
                                        <span className={`human-health-badge ${api.category.replace(/\s+/g, '-')}`}>
                                            {api.category}
                                        </span>
                                    </td> */}
                                    <td className="dosage">{api.form}</td>
                                    <td className="strength">{api.strength}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <section className="dev-section">

                <h2 className="dev-title">Development-Stage Products</h2>
                <div className="human-health-api-section-divider">
                    <span className="human-health-api-line left"></span>

                    <div className="human-health-api-icon-circle">
                        <img src={minLogo} alt="company overview" />
                    </div>

                    <span className="human-health-api-line right"></span>
                </div>

                <p className="dev-subtitle">
                    12 finished dosage products currently under active development
                </p>


                <div className="human-health-filter-buttons dev-filter-buttons">
                    {developfilters.map((item) => (
                        <button
                            key={item.name}
                            className={`human-health-filter-pill ${item.name.replace(/\s+/g, '-')} ${item.name === activeCategory ? "active" : ""}`}
                            onClick={() => setActiveCategory(item.name)}
                        >
                            {item.name}
                        </button>
                    ))}
                </div>
                <div className="human-health-table-wrapper">
                    <table className="human-health-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product</th>
                                {/* <th>Category</th> */}
                                <th>Dosage Form</th>
                                <th>Strength(s)</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredDevData.map((api, index) => (
                                <tr key={index}>
                                    <td className="api-id">{index + 1}</td>
                                    <td className="product-name">{api.name}</td>
                                    {/* <td>
                                        <span className={`human-health-badge ${api.category.replace(/\s+/g, '-')}`}>
                                            {api.category}
                                        </span>
                                    </td> */}
                                    <td className="dosage">{api.form}</td>
                                    <td className="strength">{api.strength}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
            <section className="pipeline-container dev-section">

                <h2 className="dev-title">Pipeline Products</h2>
                <div className="human-health-api-section-divider">
                    <span className="human-health-api-line left"></span>

                    <div className="human-health-api-icon-circle">
                        <img src={minLogo} alt="company overview" />
                    </div>

                    <span className="human-health-api-line right"></span>
                </div>

                <p className="dev-subtitle">
                    17 products with active filing strategies across P-IV, NCE-1 and 505(b)(2) pathways
                </p>

                <div className="human-health-filter-buttons dev-filter-buttons">
                    {pipelineFilters.map((item) => (
                        <button
                            key={item.name}
                            className={`human-health-filter-pill ${item.name.replace(/\s+/g, '-')} ${item.name === activeCategory ? "active" : ""}`}
                            onClick={() => setActiveCategory(item.name)}
                        >
                            {item.name}
                        </button>
                    ))}
                </div>

                <div className="human-health-table-wrapper">
                    <table className="human-health-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product</th>
                                <th>Strengths</th>
                                <th>Development</th>
                                <th>Filing approach</th>
                                <th>Tent. Launch</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredPipelineData.map((api, index) => (
                                <tr key={index}>
                                    <td className="api-id">{index + 1}</td>
                                    <td className="product-name">{api.name}</td>
                                    <td className="strength">{api.strength}</td>
                                    <td className="development">{api.filing}</td>
                                    <td className="filing">{api.approval}</td>
                                    <td className="tent-launch">{api.launch}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
            {/* <section className="human-health-dosage-section">
                <h2 className="human-health-dosage-title">Dosage</h2>
                <div className="human-health-api-section-divider">
                    <span className="human-health-api-line left"></span>

                    <div className="human-health-api-icon-circle">
                        <img src={minLogo} alt="company overview" />
                    </div>

                    <span className="human-health-api-line right"></span>
                </div>
                <div className="human-health-dosage-grid">
                    {dosageData.map((item, index) => (
                        <div className="human-health-dosage-card" key={index}>
                            <div className="human-health-icon-circle">
                                <Icon type={item.icon} />
                            </div>
                            <div className="human-health-dosage-content">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                                <div className="human-health-dosage-count">
                                    <AnimatedCounter value={item.count} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}
            <section className="regulatory-section">
                <div className="regulatory-container">

                    <h2 className="regulatory-title">
                        Regulatory & IP Strength
                    </h2>

                    <div className="human-health-api-section-divider">
                        <span className="human-health-api-line left"></span>

                        <div className="human-health-api-icon-circle">
                            <img src={minLogo} alt="company overview" />
                        </div>

                        <span className="human-health-api-line right"></span>
                    </div>

                    <p className="regulatory-subtitle">
                        Extensive experience in patent litigation, lifecycle management, and
                        regulatory filings across major global markets.
                    </p>

                    <div className="regulatory-highlight">
                        <div className="highlight-icon">
                            <img src={file} alt="file icon" />
                        </div>

                        <p className="highlight-text">
                            <strong><AnimatedCounter value="33" /> ANDAs Approved</strong> – Regulatory Filings Across Geographies
                        </p>
                    </div>

                </div>
            </section>
            <section className="manufacturing-section">
                <div className="manufacturing-container">

                    <h2 className="manufacturing-title">
                        Manufacturing Strength & Capabilities
                    </h2>

                    <div className="human-health-api-section-divider">
                        <span className="human-health-api-line left"></span>

                        <div className="human-health-api-icon-circle">
                            <img src={minLogo} alt="company overview" />
                        </div>

                        <span className="human-health-api-line right"></span>
                    </div>

                    <p className="manufacturing-subtitle">
                        Modern packaging lines for diverse formats and customer requirements
                    </p>

                    <div className="human-health-table-wrapper">
                        <table className="human-health-table">
                            <thead>
                                <tr>
                                    {/*      */}
                                    <th>Manufacturing Technologies</th>
                                    <th>Packaging Capabilities</th>
                                </tr>
                            </thead>
                            <tbody>
                                {manufacturingData.map((item, index) => (
                                    <tr key={index}>
                                        {/* <td className="api-id">{index + 1}</td> */}
                                        <td className="tech">
                                            <strong>{item.tech}</strong>
                                            <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b" }}>{item.desc}</p>
                                        </td>
                                        <td className="pack">{item.pack}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default HumanHealth;
